/* 
* This file is auto-generated by Graphweaver. 
* Please do not edit it directly.
*/
import * as Types from '../../../../backend/src/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetUserSubscriptionChargesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetUserSubscriptionChargesQuery = { __typename?: 'Query', userSubscriptionCharges?: Array<{ __typename?: 'StripeCharge', id: string, created: number, receiptUrl: string, receiptNumber: number } | null> | null };


export const GetUserSubscriptionChargesDocument = gql`
    query GetUserSubscriptionCharges {
  userSubscriptionCharges {
    id
    created
    receiptUrl
    receiptNumber
  }
}
    `;

/**
 * __useGetUserSubscriptionChargesQuery__
 *
 * To run a query within a React component, call `useGetUserSubscriptionChargesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserSubscriptionChargesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserSubscriptionChargesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserSubscriptionChargesQuery(baseOptions?: Apollo.QueryHookOptions<GetUserSubscriptionChargesQuery, GetUserSubscriptionChargesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserSubscriptionChargesQuery, GetUserSubscriptionChargesQueryVariables>(GetUserSubscriptionChargesDocument, options);
      }
export function useGetUserSubscriptionChargesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserSubscriptionChargesQuery, GetUserSubscriptionChargesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserSubscriptionChargesQuery, GetUserSubscriptionChargesQueryVariables>(GetUserSubscriptionChargesDocument, options);
        }
export function useGetUserSubscriptionChargesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserSubscriptionChargesQuery, GetUserSubscriptionChargesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserSubscriptionChargesQuery, GetUserSubscriptionChargesQueryVariables>(GetUserSubscriptionChargesDocument, options);
        }
export type GetUserSubscriptionChargesQueryHookResult = ReturnType<typeof useGetUserSubscriptionChargesQuery>;
export type GetUserSubscriptionChargesLazyQueryHookResult = ReturnType<typeof useGetUserSubscriptionChargesLazyQuery>;
export type GetUserSubscriptionChargesSuspenseQueryHookResult = ReturnType<typeof useGetUserSubscriptionChargesSuspenseQuery>;
export type GetUserSubscriptionChargesQueryResult = Apollo.QueryResult<GetUserSubscriptionChargesQuery, GetUserSubscriptionChargesQueryVariables>;